var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"win",attrs:{"src":_vm.http}})
}
var staticRenderFns = []

export { render, staticRenderFns }